import React from 'react';
import PropTypes from 'prop-types';
import NumberDisplay from '../number-display';
import styles from './styles.css';
import { getColorFromKey } from '../../util/helpers';

function BarChartRenderer(props) {
  const {
    value, precision,
    lowerBound, upperBound,
  } = props;
  if (value === null) {
    return null;
  }

  

  const p = Math.min(value, 100);

  let color = null;
  if (p === null) {
    color = '20,20,20';
  } else if (p >= 0 && p < lowerBound) {
    color = getColorFromKey('lost', true);
  } else if (p >= lowerBound && p <= upperBound) {
    color = getColorFromKey('noDecision', true);
  } else if (p > upperBound) {
    color = getColorFromKey('won', true);
  }

  const style = {
    backgroundColor: '#222',
    backgroundImage: `linear-gradient(to right, #fff 0%, #fff ${p}%, #222 ${p}%, #222 100%)`,
  };
  return (
    <span className={styles.barChart}>
      <span className={styles.barChartNumber} style={style}>
        <NumberDisplay value={value} precision={precision} suffix="%" />
      </span>
      <span style={{ width: `${p}%`, background: `rgba(${color},1)` }} className={styles.barChartBar} />
    </span>
  );
}

BarChartRenderer.propTypes = {
  value: PropTypes.number,
  precision: PropTypes.number,
  lowerBound: PropTypes.number,
  upperBound: PropTypes.number,
};
BarChartRenderer.defaultProps = {
  value: null,
  precision: 1,
  lowerBound: 50,
  upperBound: 80,
};

export default BarChartRenderer;
